export interface StringsType {
  domain: string;
  lang: string;
  completeness: number;
  plural_forms: string;
  locale_data: {
    messages: Record<string, unknown>;
  };
  _pogen?: {
    total: number;
    translated: number;
    untranslated: string[];
    optional: string[];
  };
}
export const strings: Record<string, StringsType> = {};

import { composeTranslationCatalogues } from "@gnu-taler/taler-util";
import { strings as pogenDependencyCatalogue0 } from "@gnu-taler/web-util/i18n";
strings["it"] = {
  locale_data: {
    messages: {
      "": {
        domain: "messages",
        lang: "it",
        plural_forms: "nplurals=2; plural=(n != 1);",
      },
      "Contact": ["Recapito"],
      "Code": ["Codice"],
      "Complete": ["Completata"],
      "Verification progress": ["Avanzamento della verifica"],
      "Technical details": ["Dettagli tecnici"],
      "Copy details": ["Copia dettagli"],
      "Copied": ["Copiato"],
      "Return to %1$s": ["Torna a %1$s"],
      "No attempts remain": ["Non rimangono tentativi"],
      "No verification attempts remain": [
        "Non rimangono tentativi di verifica",
      ],
      "Loading verification…": ["Caricamento della verifica…"],
      "This can take a few seconds.": [
        "L’operazione può richiedere alcuni secondi.",
      ],
      "Verification service unavailable": [
        "Servizio di verifica non disponibile",
      ],
      "We could not load this verification": [
        "Impossibile caricare questa verifica",
      ],
      "Check your connection and try again. Your progress is safe.": [
        "Controlla la connessione e riprova. I progressi non andranno persi.",
      ],
      "Loading…": ["Caricamento…"],
      "Try again": ["Riprova"],
      "Verification link expired": ["Link di verifica scaduto"],
      "Invalid verification link": ["Link di verifica non valido"],
      "This verification is no longer available. Return to the application and start again.":
        [
          "Questa verifica non è più disponibile. Torna all’applicazione e ricomincia.",
        ],
      "Return to the application and start a new verification.": [
        "Torna all’applicazione e avvia una nuova verifica.",
      ],
      "The service had a temporary problem. Try again.": [
        "Il servizio ha riscontrato un problema temporaneo. Riprova.",
      ],
      "The verification request is incomplete or invalid.": [
        "La richiesta di verifica è incompleta o non valida.",
      ],
      "Continuing…": ["Passaggio alla fase successiva…"],
      "Loading contact details…": ["Caricamento dei dati di contatto…"],
      "We could not load your verification": [
        "Impossibile caricare la verifica",
      ],
      "Could not load verification details": [
        "Impossibile caricare i dettagli della verifica",
      ],
      "Verification unavailable": ["Verifica non disponibile"],
      "This verification has expired. Return to the application and start again.":
        ["Questa verifica è scaduta. Torna all’applicazione e ricomincia."],
      "No attempts remain. Return to the application and start a new verification.":
        [
          "Non rimangono tentativi. Torna all’applicazione e avvia una nuova verifica.",
        ],
      "The service rejected this verification request.": [
        "Il servizio ha rifiutato questa richiesta di verifica.",
      ],
      "Invalid validation rule: %1$s": ["Regola di convalida non valida: %1$s"],
      "Service configuration error": ["Errore di configurazione del servizio"],
      "The service cannot validate this address right now. Please return to the application and try again later.":
        [
          "Al momento il servizio non può verificare questo indirizzo. Torna all’applicazione e riprova più tardi.",
        ],
      "We could not contact the verification service. Check your connection and try again.":
        [
          "Impossibile contattare il servizio di verifica. Controlla la connessione e riprova.",
        ],
      "Verify your email address": ["Verifica il tuo indirizzo e-mail"],
      "Verify your phone number": ["Verifica il tuo numero di telefono"],
      "Verify your postal address": ["Verifica il tuo indirizzo postale"],
      "We will email you a one-time verification code.": [
        "Ti invieremo tramite e-mail un codice di verifica monouso.",
      ],
      "We will send you a one-time verification code by SMS.": [
        "Ti invieremo tramite SMS un codice di verifica monouso.",
      ],
      "We will send you a letter containing a one-time verification code.": [
        "Ti invieremo una lettera contenente un codice di verifica monouso.",
      ],
      "Change your email address": ["Cambia il tuo indirizzo e-mail"],
      "Change your phone number": ["Cambia il tuo numero di telefono"],
      "Change your postal address": ["Cambia il tuo indirizzo postale"],
      "Enter the email address where you want to receive a new verification code.":
        [
          "Inserisci l’indirizzo e-mail al quale desideri ricevere un nuovo codice di verifica.",
        ],
      "Enter the phone number where you want to receive a new verification code.":
        [
          "Inserisci il numero di telefono sul quale desideri ricevere un nuovo codice di verifica.",
        ],
      "Enter the postal address where you want to receive a new verification code.":
        [
          "Inserisci l’indirizzo postale al quale desideri ricevere un nuovo codice di verifica.",
        ],
      "Current email address": ["Indirizzo e-mail attuale"],
      "Current phone number": ["Numero di telefono attuale"],
      "Current postal address": ["Indirizzo postale attuale"],
      "New postal address": ["Nuovo indirizzo postale"],
      "Last available change": ["Ultima modifica disponibile"],
      "You can change the email address one more time.": [
        "Puoi cambiare l’indirizzo e-mail ancora una volta.",
      ],
      "You can change the phone number one more time.": [
        "Puoi cambiare il numero di telefono ancora una volta.",
      ],
      "You can change the postal address one more time.": [
        "Puoi cambiare l’indirizzo postale ancora una volta.",
      ],
      "Change at least one field to continue.": [
        "Modifica almeno un campo per continuare.",
      ],
      "The previous code sent to %1$s can still be used.": [
        "Il codice precedente inviato a %1$s può ancora essere usato.",
      ],
      "Back to code entry": ["Torna all’inserimento del codice"],
      "No changes remaining": ["Non sono disponibili altre modifiche"],
      "Email address cannot be changed": [
        "L’indirizzo e-mail non può essere modificato",
      ],
      "Phone number cannot be changed": [
        "Il numero di telefono non può essere modificato",
      ],
      "Postal address cannot be changed": [
        "L’indirizzo postale non può essere modificato",
      ],
      "This email address cannot be changed.": [
        "Questo indirizzo e-mail non può essere modificato.",
      ],
      "This phone number cannot be changed.": [
        "Questo numero di telefono non può essere modificato.",
      ],
      "This postal address cannot be changed.": [
        "Questo indirizzo postale non può essere modificato.",
      ],
      "Code could not be sent": ["Impossibile inviare il codice"],
      "Sending code…": ["Invio del codice…"],
      "Send verification code": ["Invia il codice di verifica"],
      "Send code to new email address": [
        "Invia il codice al nuovo indirizzo e-mail",
      ],
      "Send code to new phone number": [
        "Invia il codice al nuovo numero di telefono",
      ],
      "Send code to new postal address": [
        "Invia il codice al nuovo indirizzo postale",
      ],
      "The code could not be delivered to this destination. Check it or use a different one.":
        [
          "Impossibile recapitare il codice a questa destinazione. Controllala o usane un’altra.",
        ],
      "This destination does not meet the service requirements. Check the highlighted fields.":
        [
          "Questa destinazione non soddisfa i requisiti del servizio. Controlla i campi evidenziati.",
        ],
      "This destination could not be used. Check it and try again.": [
        "Impossibile usare questa destinazione. Controllala e riprova.",
      ],
      "This destination is fixed and cannot be changed.": [
        "Questa destinazione è fissa e non può essere modificata.",
      ],
      "The verification service is not configured to send this code.": [
        "Il servizio di verifica non è configurato per inviare questo codice.",
      ],
      "The destination is too long. Shorten it and try again.": [
        "La destinazione è troppo lunga. Abbreviala e riprova.",
      ],
      "The verification page and service are incompatible.": [
        "La pagina e il servizio di verifica non sono compatibili.",
      ],
      "No more codes can be sent for this verification. Use a different destination or start again.":
        [
          "Non è possibile inviare altri codici per questa verifica. Usa un’altra destinazione o ricomincia.",
        ],
      "The delivery service is temporarily unavailable. Try again in a moment.":
        [
          "Il servizio di recapito è temporaneamente non disponibile. Riprova tra poco.",
        ],
      "The verification service had a temporary problem. Try again.": [
        "Il servizio di verifica ha riscontrato un problema temporaneo. Riprova.",
      ],
      "The code could not be sent. Try again.": [
        "Impossibile inviare il codice. Riprova.",
      ],
      "Enter a valid value.": ["Inserisci un valore valido."],
      "Email": ["E-mail"],
      "New email address": ["Nuovo indirizzo e-mail"],
      "Phone": ["Telefono"],
      "New phone number": ["Nuovo numero di telefono"],
      "Contact name": ["Nome del contatto"],
      "Full name of the person or business": [
        "Nome completo della persona o dell’azienda",
      ],
      "Address": ["Indirizzo"],
      "Street and house number\nAdditional address information\nPostal code and city":
        [
          "Via e numero civico\nInformazioni aggiuntive sull’indirizzo\nCodice postale e città",
        ],
      "Country": ["Paese"],
      "Your full name": ["Il tuo nome completo"],
      "Swiss address": ["Indirizzo svizzero"],
      "Make sure this is a Swiss address.": [
        "Assicurati che si tratti di un indirizzo svizzero.",
      ],
      "The verification code is incorrect.": [
        "Il codice di verifica non è corretto.",
      ],
      "The verification service rejected this request.": [
        "Il servizio di verifica ha rifiutato questa richiesta.",
      ],
      "Updating verification status…": [
        "Aggiornamento dello stato della verifica…",
      ],
      "This verification code can no longer be used": [
        "Questo codice di verifica non può più essere usato",
      ],
      "Choose another available option or return to the application and start again.":
        [
          "Scegli un’altra opzione disponibile oppure torna all’applicazione e ricomincia.",
        ],
      "Enter your verification code": ["Inserisci il codice di verifica"],
      "Enter the one-time verification code you received.": [
        "Inserisci il codice di verifica monouso che hai ricevuto.",
      ],
      "New code sent": ["Nuovo codice inviato"],
      "A new code was sent. Enter the latest code you received.": [
        "È stato inviato un nuovo codice. Inserisci l’ultimo codice ricevuto.",
      ],
      "Verification code": ["Codice di verifica"],
      "Code not accepted": ["Codice non accettato"],
      "This is your last attempt with the current code.": [
        "Questo è l’ultimo tentativo con il codice attuale.",
      ],
      "Verifying…": ["Verifica in corso…"],
      "Verify code": ["Verifica il codice"],
      "We sent a one-time verification code to %1$s.": [
        "Abbiamo inviato un codice di verifica monouso a %1$s.",
      ],
      "Use a different email address": ["Usa un altro indirizzo e-mail"],
      "Use a different phone number": ["Usa un altro numero di telefono"],
      "Use a different postal address": ["Usa un altro indirizzo postale"],
      "The email address can no longer be changed.": [
        "L’indirizzo e-mail non può più essere modificato.",
      ],
      "The phone number can no longer be changed.": [
        "Il numero di telefono non può più essere modificato.",
      ],
      "The postal address can no longer be changed.": [
        "L’indirizzo postale non può più essere modificato.",
      ],
      "Sending a new code…": ["Invio di un nuovo codice…"],
      "Send a new code": ["Invia un nuovo codice"],
      "Didn't receive a code?": ["Non hai ricevuto il codice?"],
      "Continue verification": ["Continua la verifica"],
      "You can send a new code in %1$s.": [
        "Potrai inviare un nuovo codice tra %1$s.",
      ],
      "No more codes can be sent for this verification.": [
        "Non è possibile inviare altri codici per questa verifica.",
      ],
      "No destination is available for another code.": [
        "Non è disponibile alcuna destinazione a cui inviare un altro codice.",
      ],
      "The verification code must contain only numbers.": [
        "Il codice di verifica deve contenere solo numeri.",
      ],
      "The verification code is too long.": [
        "Il codice di verifica è troppo lungo.",
      ],
      "The verification code could not be checked. Try again.": [
        "Impossibile controllare il codice di verifica. Riprova.",
      ],
      "Continue to %1$s": ["Continua su %1$s"],
      "Verification complete": ["Verifica completata"],
      "Return to the application that started this verification.": [
        "Torna all’applicazione che ha avviato questa verifica.",
      ],
      "Use the button below to continue immediately.": [
        "Usa il pulsante qui sotto per continuare subito.",
      ],
      "You will be redirected to %1$s automatically.": [
        "Verrai reindirizzato automaticamente a %1$s.",
      ],
      "Redirecting in 1 second…": ["Reindirizzamento tra 1 secondo…"],
      "Redirecting in %1$s seconds…": ["Reindirizzamento tra %1$s secondi…"],
      "Automatic return is unavailable": [
        "Il ritorno automatico non è disponibile",
      ],
      "Address verified": ["Indirizzo verificato"],
      "Identity verification": ["Verifica dell’identità"],
      "Something went wrong": ["Si è verificato un problema"],
      "Reload this page. If the problem continues, return to the application that started the verification.":
        [
          "Ricarica questa pagina. Se il problema persiste, torna all’applicazione che ha avviato la verifica.",
        ],
      "Client password": ["Password del client"],
      "Redirect URL": ["URL di reindirizzamento"],
      "Required": ["Obbligatorio"],
      "Enter a valid HTTP or HTTPS URL": [
        "Inserisci un URL HTTP o HTTPS valido",
      ],
      "The client ID or password is not recognized by this service.": [
        "L’ID client o la password non sono riconosciuti da questo servizio.",
      ],
      "The verification session could not be created.": [
        "Impossibile creare la sessione di verifica.",
      ],
      "We could not contact the verification service. Check the service URL and try again.":
        [
          "Impossibile contattare il servizio di verifica. Controlla l’URL del servizio e riprova.",
        ],
      "Create a verification session": ["Crea una sessione di verifica"],
      "Session not created": ["Sessione non creata"],
      "Creating session…": ["Creazione della sessione…"],
      "Create session": ["Crea sessione"],
      "Developer setup for client %1$s": [
        "Configurazione per sviluppatori del client %1$s",
      ],
      "No verification attempts or address changes remain.": [
        "Non rimangono tentativi di verifica né modifiche dell’indirizzo.",
      ],
      "Verification information unavailable": [
        "Informazioni di verifica non disponibili",
      ],
      "Nothing to verify": ["Niente da verificare"],
      "Return to the application that sent you here and start the verification again.":
        [
          "Torna all’applicazione che ti ha indirizzato qui e ricomincia la verifica.",
        ],
      "Required information is missing": ["Mancano informazioni obbligatorie"],
      "Preparing verification…": ["Preparazione della verifica…"],
      "Retry %1$s of %2$s": ["Tentativo di riconnessione %1$s di %2$s"],
      "Reconnecting to the verification service…": [
        "Riconnessione al servizio di verifica…",
      ],
      "Connecting to the verification service…": [
        "Connessione al servizio di verifica…",
      ],
      "unknown": ["sconosciuta"],
      "Supported version: %1$s. Service version: %2$s.": [
        "Versione supportata: %1$s. Versione del servizio: %2$s.",
      ],
      "Verification service update required": [
        "È necessario aggiornare il servizio di verifica",
      ],
      "Versions are incompatible": ["Le versioni non sono compatibili"],
      "This verification page cannot communicate with the service. Please return to the application that sent you here.":
        [
          "Questa pagina di verifica non può comunicare con il servizio. Torna all’applicazione che ti ha indirizzato qui.",
        ],
      "We could not connect": ["Impossibile connettersi"],
      "Check your connection and try again. Your verification information has not been changed.":
        [
          "Controlla la connessione e riprova. Le informazioni di verifica non sono state modificate.",
        ],
      "Connecting…": ["Connessione…"],
    },
  },
  domain: "messages",
  plural_forms: "nplurals=2; plural=(n != 1);",
  lang: "it",
  completeness: 100,
  _pogen: {
    total: 167,
    translated: 167,
    untranslated: [],
    optional: [],
  },
};

strings["fr"] = {
  locale_data: {
    messages: {
      "": {
        domain: "messages",
        lang: "fr",
        plural_forms: "nplurals=2; plural=(n > 1);",
      },
      "Contact": ["Coordonnées"],
      "Code": ["Code"],
      "Complete": ["Terminée"],
      "Verification progress": ["Progression de la vérification"],
      "Technical details": ["Détails techniques"],
      "Copy details": ["Copier les détails"],
      "Copied": ["Copié"],
      "Return to %1$s": ["Retour à %1$s"],
      "No attempts remain": ["Aucune tentative restante"],
      "No verification attempts remain": [
        "Aucune tentative de vérification restante",
      ],
      "Loading verification…": ["Chargement de la vérification…"],
      "This can take a few seconds.": ["Cela peut prendre quelques secondes."],
      "Verification service unavailable": [
        "Service de vérification indisponible",
      ],
      "We could not load this verification": [
        "Impossible de charger cette vérification",
      ],
      "Check your connection and try again. Your progress is safe.": [
        "Vérifiez votre connexion et réessayez. Votre progression est conservée.",
      ],
      "Loading…": ["Chargement…"],
      "Try again": ["Réessayer"],
      "Verification link expired": ["Lien de vérification expiré"],
      "Invalid verification link": ["Lien de vérification non valide"],
      "This verification is no longer available. Return to the application and start again.":
        [
          "Cette vérification n’est plus disponible. Revenez à l’application et recommencez.",
        ],
      "Return to the application and start a new verification.": [
        "Revenez à l’application et démarrez une nouvelle vérification.",
      ],
      "The service had a temporary problem. Try again.": [
        "Le service a rencontré un problème temporaire. Réessayez.",
      ],
      "The verification request is incomplete or invalid.": [
        "La demande de vérification est incomplète ou non valide.",
      ],
      "Continuing…": ["Passage à l’étape suivante…"],
      "Loading contact details…": ["Chargement des coordonnées…"],
      "We could not load your verification": [
        "Impossible de charger votre vérification",
      ],
      "Could not load verification details": [
        "Impossible de charger les détails de la vérification",
      ],
      "Verification unavailable": ["Vérification indisponible"],
      "This verification has expired. Return to the application and start again.":
        [
          "Cette vérification a expiré. Revenez à l’application et recommencez.",
        ],
      "No attempts remain. Return to the application and start a new verification.":
        [
          "Il ne reste aucune tentative. Revenez à l’application et démarrez une nouvelle vérification.",
        ],
      "The service rejected this verification request.": [
        "Le service a rejeté cette demande de vérification.",
      ],
      "Invalid validation rule: %1$s": [
        "Règle de validation non valide : %1$s",
      ],
      "Service configuration error": ["Erreur de configuration du service"],
      "The service cannot validate this address right now. Please return to the application and try again later.":
        [
          "Le service ne peut pas vérifier cette adresse pour le moment. Revenez à l’application et réessayez plus tard.",
        ],
      "We could not contact the verification service. Check your connection and try again.":
        [
          "Impossible de contacter le service de vérification. Vérifiez votre connexion et réessayez.",
        ],
      "Verify your email address": ["Vérifiez votre adresse e-mail"],
      "Verify your phone number": ["Vérifiez votre numéro de téléphone"],
      "Verify your postal address": ["Vérifiez votre adresse postale"],
      "We will email you a one-time verification code.": [
        "Nous vous enverrons un code de vérification à usage unique par e-mail.",
      ],
      "We will send you a one-time verification code by SMS.": [
        "Nous vous enverrons un code de vérification à usage unique par SMS.",
      ],
      "We will send you a letter containing a one-time verification code.": [
        "Nous vous enverrons une lettre contenant un code de vérification à usage unique.",
      ],
      "Change your email address": ["Modifier votre adresse e-mail"],
      "Change your phone number": ["Modifier votre numéro de téléphone"],
      "Change your postal address": ["Modifier votre adresse postale"],
      "Enter the email address where you want to receive a new verification code.":
        [
          "Saisissez l’adresse e-mail à laquelle vous souhaitez recevoir un nouveau code de vérification.",
        ],
      "Enter the phone number where you want to receive a new verification code.":
        [
          "Saisissez le numéro de téléphone sur lequel vous souhaitez recevoir un nouveau code de vérification.",
        ],
      "Enter the postal address where you want to receive a new verification code.":
        [
          "Saisissez l’adresse postale à laquelle vous souhaitez recevoir un nouveau code de vérification.",
        ],
      "Current email address": ["Adresse e-mail actuelle"],
      "Current phone number": ["Numéro de téléphone actuel"],
      "Current postal address": ["Adresse postale actuelle"],
      "New postal address": ["Nouvelle adresse postale"],
      "Last available change": ["Dernière modification disponible"],
      "You can change the email address one more time.": [
        "Vous pouvez encore modifier l’adresse e-mail une fois.",
      ],
      "You can change the phone number one more time.": [
        "Vous pouvez encore modifier le numéro de téléphone une fois.",
      ],
      "You can change the postal address one more time.": [
        "Vous pouvez encore modifier l’adresse postale une fois.",
      ],
      "Change at least one field to continue.": [
        "Modifiez au moins un champ pour continuer.",
      ],
      "The previous code sent to %1$s can still be used.": [
        "Le code précédent envoyé à %1$s peut encore être utilisé.",
      ],
      "Back to code entry": ["Retour à la saisie du code"],
      "No changes remaining": ["Aucune modification disponible"],
      "Email address cannot be changed": [
        "L’adresse e-mail ne peut pas être modifiée",
      ],
      "Phone number cannot be changed": [
        "Le numéro de téléphone ne peut pas être modifié",
      ],
      "Postal address cannot be changed": [
        "L’adresse postale ne peut pas être modifiée",
      ],
      "This email address cannot be changed.": [
        "Cette adresse e-mail ne peut pas être modifiée.",
      ],
      "This phone number cannot be changed.": [
        "Ce numéro de téléphone ne peut pas être modifié.",
      ],
      "This postal address cannot be changed.": [
        "Cette adresse postale ne peut pas être modifiée.",
      ],
      "Code could not be sent": ["Le code n’a pas pu être envoyé"],
      "Sending code…": ["Envoi du code…"],
      "Send verification code": ["Envoyer le code de vérification"],
      "Send code to new email address": [
        "Envoyer le code à la nouvelle adresse e-mail",
      ],
      "Send code to new phone number": [
        "Envoyer le code au nouveau numéro de téléphone",
      ],
      "Send code to new postal address": [
        "Envoyer le code à la nouvelle adresse postale",
      ],
      "The code could not be delivered to this destination. Check it or use a different one.":
        [
          "Le code n’a pas pu être envoyé à cette destination. Vérifiez-la ou utilisez-en une autre.",
        ],
      "This destination does not meet the service requirements. Check the highlighted fields.":
        [
          "Cette destination ne répond pas aux exigences du service. Vérifiez les champs mis en évidence.",
        ],
      "This destination could not be used. Check it and try again.": [
        "Cette destination n’a pas pu être utilisée. Vérifiez-la et réessayez.",
      ],
      "This destination is fixed and cannot be changed.": [
        "Cette destination est imposée et ne peut pas être modifiée.",
      ],
      "The verification service is not configured to send this code.": [
        "Le service de vérification n’est pas configuré pour envoyer ce code.",
      ],
      "The destination is too long. Shorten it and try again.": [
        "La destination est trop longue. Raccourcissez-la et réessayez.",
      ],
      "The verification page and service are incompatible.": [
        "La page et le service de vérification sont incompatibles.",
      ],
      "No more codes can be sent for this verification. Use a different destination or start again.":
        [
          "Aucun autre code ne peut être envoyé pour cette vérification. Utilisez une autre destination ou recommencez.",
        ],
      "The delivery service is temporarily unavailable. Try again in a moment.":
        [
          "Le service d’envoi est temporairement indisponible. Réessayez dans un instant.",
        ],
      "The verification service had a temporary problem. Try again.": [
        "Le service de vérification a rencontré un problème temporaire. Réessayez.",
      ],
      "The code could not be sent. Try again.": [
        "Le code n’a pas pu être envoyé. Réessayez.",
      ],
      "Enter a valid value.": ["Saisissez une valeur valide."],
      "Email": ["Courriel"],
      "New email address": ["Nouvelle adresse e-mail"],
      "Phone": ["Téléphone"],
      "New phone number": ["Nouveau numéro de téléphone"],
      "Contact name": ["Nom du contact"],
      "Full name of the person or business": [
        "Nom complet de la personne ou de l’entreprise",
      ],
      "Address": ["Adresse"],
      "Street and house number\nAdditional address information\nPostal code and city":
        ["Rue et numéro\nComplément d’adresse\nCode postal et ville"],
      "Country": ["Pays"],
      "Your full name": ["Votre nom complet"],
      "Swiss address": ["Adresse suisse"],
      "Make sure this is a Swiss address.": [
        "Assurez-vous qu’il s’agit d’une adresse en Suisse.",
      ],
      "The verification code is incorrect.": [
        "Le code de vérification est incorrect.",
      ],
      "The verification service rejected this request.": [
        "Le service de vérification a rejeté cette demande.",
      ],
      "Updating verification status…": [
        "Mise à jour de l’état de la vérification…",
      ],
      "This verification code can no longer be used": [
        "Ce code de vérification ne peut plus être utilisé",
      ],
      "Choose another available option or return to the application and start again.":
        [
          "Choisissez une autre option disponible ou revenez à l’application et recommencez.",
        ],
      "Enter your verification code": ["Saisissez votre code de vérification"],
      "Enter the one-time verification code you received.": [
        "Saisissez le code de vérification à usage unique que vous avez reçu.",
      ],
      "New code sent": ["Nouveau code envoyé"],
      "A new code was sent. Enter the latest code you received.": [
        "Un nouveau code a été envoyé. Saisissez le dernier code que vous avez reçu.",
      ],
      "Verification code": ["Code de vérification"],
      "Code not accepted": ["Code non accepté"],
      "This is your last attempt with the current code.": [
        "C’est votre dernière tentative avec le code actuel.",
      ],
      "Verifying…": ["Vérification…"],
      "Verify code": ["Vérifier le code"],
      "We sent a one-time verification code to %1$s.": [
        "Nous avons envoyé un code de vérification à usage unique à %1$s.",
      ],
      "Use a different email address": ["Utiliser une autre adresse e-mail"],
      "Use a different phone number": ["Utiliser un autre numéro de téléphone"],
      "Use a different postal address": ["Utiliser une autre adresse postale"],
      "The email address can no longer be changed.": [
        "L’adresse e-mail ne peut plus être modifiée.",
      ],
      "The phone number can no longer be changed.": [
        "Le numéro de téléphone ne peut plus être modifié.",
      ],
      "The postal address can no longer be changed.": [
        "L’adresse postale ne peut plus être modifiée.",
      ],
      "Sending a new code…": ["Envoi d’un nouveau code…"],
      "Send a new code": ["Envoyer un nouveau code"],
      "Didn't receive a code?": ["Vous n’avez pas reçu de code ?"],
      "Continue verification": ["Poursuivre la vérification"],
      "You can send a new code in %1$s.": [
        "Vous pourrez envoyer un nouveau code dans %1$s.",
      ],
      "No more codes can be sent for this verification.": [
        "Aucun autre code ne peut être envoyé pour cette vérification.",
      ],
      "No destination is available for another code.": [
        "Aucune destination n’est disponible pour envoyer un autre code.",
      ],
      "The verification code must contain only numbers.": [
        "Le code de vérification doit contenir uniquement des chiffres.",
      ],
      "The verification code is too long.": [
        "Le code de vérification est trop long.",
      ],
      "The verification code could not be checked. Try again.": [
        "Le code de vérification n’a pas pu être contrôlé. Réessayez.",
      ],
      "Continue to %1$s": ["Continuer vers %1$s"],
      "Verification complete": ["Vérification terminée"],
      "Return to the application that started this verification.": [
        "Revenez à l’application qui a lancé cette vérification.",
      ],
      "Use the button below to continue immediately.": [
        "Utilisez le bouton ci-dessous pour continuer immédiatement.",
      ],
      "You will be redirected to %1$s automatically.": [
        "Vous serez automatiquement redirigé vers %1$s.",
      ],
      "Redirecting in 1 second…": ["Redirection dans 1 seconde…"],
      "Redirecting in %1$s seconds…": ["Redirection dans %1$s secondes…"],
      "Automatic return is unavailable": [
        "Le retour automatique est indisponible",
      ],
      "Address verified": ["Adresse vérifiée"],
      "Identity verification": ["Vérification d’identité"],
      "Something went wrong": ["Un problème est survenu"],
      "Reload this page. If the problem continues, return to the application that started the verification.":
        [
          "Rechargez cette page. Si le problème persiste, revenez à l’application qui a lancé la vérification.",
        ],
      "Client password": ["Mot de passe du client"],
      "Redirect URL": ["URL de redirection"],
      "Required": ["Obligatoire"],
      "Enter a valid HTTP or HTTPS URL": [
        "Saisissez une URL HTTP ou HTTPS valide",
      ],
      "The client ID or password is not recognized by this service.": [
        "L’identifiant client ou le mot de passe n’est pas reconnu par ce service.",
      ],
      "The verification session could not be created.": [
        "La session de vérification n’a pas pu être créée.",
      ],
      "We could not contact the verification service. Check the service URL and try again.":
        [
          "Impossible de contacter le service de vérification. Vérifiez l’URL du service et réessayez.",
        ],
      "Create a verification session": ["Créer une session de vérification"],
      "Session not created": ["Session non créée"],
      "Creating session…": ["Création de la session…"],
      "Create session": ["Créer la session"],
      "Developer setup for client %1$s": [
        "Configuration de développement pour le client %1$s",
      ],
      "No verification attempts or address changes remain.": [
        "Il ne reste aucune tentative de vérification ni aucune modification d’adresse.",
      ],
      "Verification information unavailable": [
        "Informations de vérification indisponibles",
      ],
      "Nothing to verify": ["Rien à vérifier"],
      "Return to the application that sent you here and start the verification again.":
        [
          "Revenez à l’application qui vous a dirigé ici et recommencez la vérification.",
        ],
      "Required information is missing": [
        "Des informations obligatoires sont manquantes",
      ],
      "Preparing verification…": ["Préparation de la vérification…"],
      "Retry %1$s of %2$s": ["Tentative de reconnexion %1$s sur %2$s"],
      "Reconnecting to the verification service…": [
        "Reconnexion au service de vérification…",
      ],
      "Connecting to the verification service…": [
        "Connexion au service de vérification…",
      ],
      "unknown": ["inconnue"],
      "Supported version: %1$s. Service version: %2$s.": [
        "Version prise en charge : %1$s. Version du service : %2$s.",
      ],
      "Verification service update required": [
        "Mise à jour du service de vérification requise",
      ],
      "Versions are incompatible": ["Les versions sont incompatibles"],
      "This verification page cannot communicate with the service. Please return to the application that sent you here.":
        [
          "Cette page de vérification ne peut pas communiquer avec le service. Revenez à l’application qui vous a dirigé ici.",
        ],
      "We could not connect": ["Impossible de se connecter"],
      "Check your connection and try again. Your verification information has not been changed.":
        [
          "Vérifiez votre connexion et réessayez. Vos informations de vérification n’ont pas été modifiées.",
        ],
      "Connecting…": ["Connexion…"],
    },
  },
  domain: "messages",
  plural_forms: "nplurals=2; plural=(n > 1);",
  lang: "fr",
  completeness: 100,
  _pogen: {
    total: 167,
    translated: 167,
    untranslated: [],
    optional: [],
  },
};

strings["es"] = {
  locale_data: {
    messages: {
      "": {
        domain: "messages",
        lang: "es",
        plural_forms: "nplurals=2; plural=(n != 1);",
      },
      "Contact": ["Contacto"],
      "Code": ["Código"],
      "Complete": ["Completado"],
      "Verification progress": ["Progreso de la verificación"],
      "Technical details": ["Detalles técnicos"],
      "Copy details": ["Copiar detalles"],
      "Copied": ["Copiado"],
      "Return to %1$s": ["Volver a %1$s"],
      "No attempts remain": ["No quedan intentos"],
      "No verification attempts remain": ["No quedan intentos de verificación"],
      "Loading verification…": ["Cargando la verificación…"],
      "This can take a few seconds.": ["Esto puede tardar unos segundos."],
      "Verification service unavailable": [
        "Servicio de verificación no disponible",
      ],
      "We could not load this verification": [
        "No pudimos cargar esta verificación",
      ],
      "Check your connection and try again. Your progress is safe.": [
        "Compruebe su conexión e inténtelo de nuevo. Su progreso está guardado.",
      ],
      "Loading…": ["Cargando…"],
      "Try again": ["Intentar de nuevo"],
      "Verification link expired": ["El enlace de verificación ha caducado"],
      "Invalid verification link": ["Enlace de verificación no válido"],
      "This verification is no longer available. Return to the application and start again.":
        [
          "Esta verificación ya no está disponible. Vuelva a la aplicación y empiece de nuevo.",
        ],
      "Return to the application and start a new verification.": [
        "Vuelva a la aplicación e inicie una nueva verificación.",
      ],
      "The service had a temporary problem. Try again.": [
        "El servicio tuvo un problema temporal. Inténtelo de nuevo.",
      ],
      "The verification request is incomplete or invalid.": [
        "La solicitud de verificación está incompleta o no es válida.",
      ],
      "Continuing…": ["Continuando…"],
      "Loading contact details…": ["Cargando los datos de contacto…"],
      "We could not load your verification": [
        "No pudimos cargar su verificación",
      ],
      "Could not load verification details": [
        "No se pudieron cargar los detalles de la verificación",
      ],
      "Verification unavailable": ["Verificación no disponible"],
      "This verification has expired. Return to the application and start again.":
        [
          "Esta verificación ha caducado. Vuelva a la aplicación y empiece de nuevo.",
        ],
      "No attempts remain. Return to the application and start a new verification.":
        [
          "No quedan intentos. Vuelva a la aplicación e inicie una nueva verificación.",
        ],
      "The service rejected this verification request.": [
        "El servicio rechazó esta solicitud de verificación.",
      ],
      "Invalid validation rule: %1$s": ["Regla de validación no válida: %1$s"],
      "Service configuration error": ["Error de configuración del servicio"],
      "The service cannot validate this address right now. Please return to the application and try again later.":
        [
          "El servicio no puede validar esta dirección en este momento. Vuelva a la aplicación e inténtelo de nuevo más tarde.",
        ],
      "We could not contact the verification service. Check your connection and try again.":
        [
          "No pudimos contactar con el servicio de verificación. Compruebe su conexión e inténtelo de nuevo.",
        ],
      "Verify your email address": [
        "Verifique su dirección de correo electrónico",
      ],
      "Verify your phone number": ["Verifique su número de teléfono"],
      "Verify your postal address": ["Verifique su dirección postal"],
      "We will email you a one-time verification code.": [
        "Le enviaremos por correo electrónico un código de verificación de un solo uso.",
      ],
      "We will send you a one-time verification code by SMS.": [
        "Le enviaremos por SMS un código de verificación de un solo uso.",
      ],
      "We will send you a letter containing a one-time verification code.": [
        "Le enviaremos una carta con un código de verificación de un solo uso.",
      ],
      "Change your email address": [
        "Cambiar su dirección de correo electrónico",
      ],
      "Change your phone number": ["Cambiar su número de teléfono"],
      "Change your postal address": ["Cambiar su dirección postal"],
      "Enter the email address where you want to receive a new verification code.":
        [
          "Introduzca la dirección de correo electrónico donde desea recibir un nuevo código de verificación.",
        ],
      "Enter the phone number where you want to receive a new verification code.":
        [
          "Introduzca el número de teléfono en el que desea recibir un nuevo código de verificación.",
        ],
      "Enter the postal address where you want to receive a new verification code.":
        [
          "Introduzca la dirección postal donde desea recibir un nuevo código de verificación.",
        ],
      "Current email address": ["Dirección de correo electrónico actual"],
      "Current phone number": ["Número de teléfono actual"],
      "Current postal address": ["Dirección postal actual"],
      "New postal address": ["Nueva dirección postal"],
      "Last available change": ["Último cambio disponible"],
      "You can change the email address one more time.": [
        "Puede cambiar la dirección de correo electrónico una vez más.",
      ],
      "You can change the phone number one more time.": [
        "Puede cambiar el número de teléfono una vez más.",
      ],
      "You can change the postal address one more time.": [
        "Puede cambiar la dirección postal una vez más.",
      ],
      "Change at least one field to continue.": [
        "Cambie al menos un campo para continuar.",
      ],
      "The previous code sent to %1$s can still be used.": [
        "El código anterior enviado a %1$s todavía se puede utilizar.",
      ],
      "Back to code entry": ["Volver a introducir el código"],
      "No changes remaining": ["No quedan cambios disponibles"],
      "Email address cannot be changed": [
        "La dirección de correo electrónico no se puede cambiar",
      ],
      "Phone number cannot be changed": [
        "El número de teléfono no se puede cambiar",
      ],
      "Postal address cannot be changed": [
        "La dirección postal no se puede cambiar",
      ],
      "This email address cannot be changed.": [
        "Esta dirección de correo electrónico no se puede cambiar.",
      ],
      "This phone number cannot be changed.": [
        "Este número de teléfono no se puede cambiar.",
      ],
      "This postal address cannot be changed.": [
        "Esta dirección postal no se puede cambiar.",
      ],
      "Code could not be sent": ["No se pudo enviar el código"],
      "Sending code…": ["Enviando el código…"],
      "Send verification code": ["Enviar el código de verificación"],
      "Send code to new email address": [
        "Enviar el código a la nueva dirección de correo electrónico",
      ],
      "Send code to new phone number": [
        "Enviar el código al nuevo número de teléfono",
      ],
      "Send code to new postal address": [
        "Enviar el código a la nueva dirección postal",
      ],
      "The code could not be delivered to this destination. Check it or use a different one.":
        [
          "No se pudo entregar el código a este destino. Compruébelo o use otro.",
        ],
      "This destination does not meet the service requirements. Check the highlighted fields.":
        [
          "Este destino no cumple los requisitos del servicio. Compruebe los campos resaltados.",
        ],
      "This destination could not be used. Check it and try again.": [
        "No se pudo usar este destino. Compruébelo e inténtelo de nuevo.",
      ],
      "This destination is fixed and cannot be changed.": [
        "Este destino es fijo y no se puede cambiar.",
      ],
      "The verification service is not configured to send this code.": [
        "El servicio de verificación no está configurado para enviar este código.",
      ],
      "The destination is too long. Shorten it and try again.": [
        "El destino es demasiado largo. Acórtelo e inténtelo de nuevo.",
      ],
      "The verification page and service are incompatible.": [
        "La página y el servicio de verificación son incompatibles.",
      ],
      "No more codes can be sent for this verification. Use a different destination or start again.":
        [
          "No se pueden enviar más códigos para esta verificación. Use un destino diferente o empiece de nuevo.",
        ],
      "The delivery service is temporarily unavailable. Try again in a moment.":
        [
          "El servicio de entrega no está disponible temporalmente. Inténtelo de nuevo en unos instantes.",
        ],
      "The verification service had a temporary problem. Try again.": [
        "El servicio de verificación tuvo un problema temporal. Inténtelo de nuevo.",
      ],
      "The code could not be sent. Try again.": [
        "No se pudo enviar el código. Inténtelo de nuevo.",
      ],
      "Enter a valid value.": ["Introduzca un valor válido."],
      "Email": ["Correo electrónico"],
      "New email address": ["Nueva dirección de correo electrónico"],
      "Phone": ["Teléfono"],
      "New phone number": ["Nuevo número de teléfono"],
      "Contact name": ["Nombre de contacto"],
      "Full name of the person or business": [
        "Nombre completo de la persona o empresa",
      ],
      "Address": ["Dirección"],
      "Street and house number\nAdditional address information\nPostal code and city":
        [
          "Calle y número\nInformación adicional de la dirección\nCódigo postal y ciudad",
        ],
      "Country": ["País"],
      "Your full name": ["Tu nombre completo"],
      "Swiss address": ["Dirección suiza"],
      "Make sure this is a Swiss address.": [
        "Asegúrate de que esta sea una dirección suiza.",
      ],
      "The verification code is incorrect.": [
        "El código de verificación es incorrecto.",
      ],
      "The verification service rejected this request.": [
        "El servicio de verificación rechazó esta solicitud.",
      ],
      "Updating verification status…": [
        "Actualizando el estado de la verificación…",
      ],
      "This verification code can no longer be used": [
        "Este código de verificación ya no se puede usar",
      ],
      "Choose another available option or return to the application and start again.":
        [
          "Elija otra opción disponible o vuelva a la aplicación y empiece de nuevo.",
        ],
      "Enter your verification code": ["Introduzca su código de verificación"],
      "Enter the one-time verification code you received.": [
        "Introduzca el código de verificación de un solo uso que recibió.",
      ],
      "New code sent": ["Nuevo código enviado"],
      "A new code was sent. Enter the latest code you received.": [
        "Se ha enviado un código nuevo. Introduzca el último código que haya recibido.",
      ],
      "Verification code": ["Código de verificación"],
      "Code not accepted": ["Código no aceptado"],
      "This is your last attempt with the current code.": [
        "Este es su último intento con el código actual.",
      ],
      "Verifying…": ["Verificando…"],
      "Verify code": ["Verificar el código"],
      "We sent a one-time verification code to %1$s.": [
        "Enviamos un código de verificación de un solo uso a %1$s.",
      ],
      "Use a different email address": [
        "Usar otra dirección de correo electrónico",
      ],
      "Use a different phone number": ["Usar otro número de teléfono"],
      "Use a different postal address": ["Usar otra dirección postal"],
      "The email address can no longer be changed.": [
        "La dirección de correo electrónico ya no se puede cambiar.",
      ],
      "The phone number can no longer be changed.": [
        "El número de teléfono ya no se puede cambiar.",
      ],
      "The postal address can no longer be changed.": [
        "La dirección postal ya no se puede cambiar.",
      ],
      "Sending a new code…": ["Enviando un código nuevo…"],
      "Send a new code": ["Enviar un código nuevo"],
      "Didn't receive a code?": ["¿No ha recibido ningún código?"],
      "Continue verification": ["Continuar con la verificación"],
      "You can send a new code in %1$s.": [
        "Podrá enviar un código nuevo en %1$s.",
      ],
      "No more codes can be sent for this verification.": [
        "No se pueden enviar más códigos para esta verificación.",
      ],
      "No destination is available for another code.": [
        "No hay ningún destino disponible para enviar otro código.",
      ],
      "The verification code must contain only numbers.": [
        "El código de verificación solo puede contener números.",
      ],
      "The verification code is too long.": [
        "El código de verificación es demasiado largo.",
      ],
      "The verification code could not be checked. Try again.": [
        "No se pudo comprobar el código de verificación. Inténtelo de nuevo.",
      ],
      "Continue to %1$s": ["Continuar a %1$s"],
      "Verification complete": ["Verificación completada"],
      "Return to the application that started this verification.": [
        "Vuelva a la aplicación que inició esta verificación.",
      ],
      "Use the button below to continue immediately.": [
        "Use el botón de abajo para continuar inmediatamente.",
      ],
      "You will be redirected to %1$s automatically.": [
        "Se le redirigirá automáticamente a %1$s.",
      ],
      "Redirecting in 1 second…": ["Redirección en 1 segundo…"],
      "Redirecting in %1$s seconds…": ["Redirección en %1$s segundos…"],
      "Automatic return is unavailable": [
        "El retorno automático no está disponible",
      ],
      "Address verified": ["Dirección verificada"],
      "Identity verification": ["Verificación de identidad"],
      "Something went wrong": ["Algo salió mal"],
      "Reload this page. If the problem continues, return to the application that started the verification.":
        [
          "Vuelva a cargar esta página. Si el problema continúa, vuelva a la aplicación que inició la verificación.",
        ],
      "Client password": ["Contraseña del cliente"],
      "Redirect URL": ["URL de redirección"],
      "Required": ["Requerido"],
      "Enter a valid HTTP or HTTPS URL": [
        "Introduzca una URL HTTP o HTTPS válida",
      ],
      "The client ID or password is not recognized by this service.": [
        "Este servicio no reconoce el ID de cliente o la contraseña.",
      ],
      "The verification session could not be created.": [
        "No se pudo crear la sesión de verificación.",
      ],
      "We could not contact the verification service. Check the service URL and try again.":
        [
          "No pudimos contactar con el servicio de verificación. Compruebe la URL del servicio e inténtelo de nuevo.",
        ],
      "Create a verification session": ["Crear una sesión de verificación"],
      "Session not created": ["No se creó la sesión"],
      "Creating session…": ["Creando la sesión…"],
      "Create session": ["Crear sesión"],
      "Developer setup for client %1$s": [
        "Configuración de desarrollo para el cliente %1$s",
      ],
      "No verification attempts or address changes remain.": [
        "No quedan intentos de verificación ni cambios de dirección.",
      ],
      "Verification information unavailable": [
        "Información de verificación no disponible",
      ],
      "Nothing to verify": ["Nada que verificar"],
      "Return to the application that sent you here and start the verification again.":
        [
          "Vuelva a la aplicación que le envió aquí e inicie la verificación de nuevo.",
        ],
      "Required information is missing": ["Falta información obligatoria"],
      "Preparing verification…": ["Preparando la verificación…"],
      "Retry %1$s of %2$s": ["Intento %1$s de %2$s"],
      "Reconnecting to the verification service…": [
        "Reconectando con el servicio de verificación…",
      ],
      "Connecting to the verification service…": [
        "Conectando con el servicio de verificación…",
      ],
      "unknown": ["desconocida"],
      "Supported version: %1$s. Service version: %2$s.": [
        "Versión compatible: %1$s. Versión del servicio: %2$s.",
      ],
      "Verification service update required": [
        "Es necesario actualizar el servicio de verificación",
      ],
      "Versions are incompatible": ["Las versiones son incompatibles"],
      "This verification page cannot communicate with the service. Please return to the application that sent you here.":
        [
          "Esta página de verificación no se puede comunicar con el servicio. Vuelva a la aplicación que le envió aquí.",
        ],
      "We could not connect": ["No pudimos conectarnos"],
      "Check your connection and try again. Your verification information has not been changed.":
        [
          "Compruebe su conexión e inténtelo de nuevo. La información de su verificación no ha cambiado.",
        ],
      "Connecting…": ["Conectando…"],
    },
  },
  domain: "messages",
  plural_forms: "nplurals=2; plural=(n != 1);",
  lang: "es",
  completeness: 100,
  _pogen: {
    total: 167,
    translated: 167,
    untranslated: [],
    optional: [],
  },
};

strings["de"] = {
  locale_data: {
    messages: {
      "": {
        domain: "messages",
        lang: "de",
        plural_forms: "nplurals=2; plural=(n != 1);",
      },
      "Contact": ["Kontakt"],
      "Code": ["Code"],
      "Complete": ["Fertig"],
      "Verification progress": ["Verifizierungsfortschritt"],
      "Technical details": ["Technische Details"],
      "Copy details": ["Details kopieren"],
      "Copied": ["Kopiert"],
      "Return to %1$s": ["Zurück zu %1$s"],
      "No attempts remain": ["Keine Versuche mehr übrig"],
      "No verification attempts remain": [
        "Keine Verifizierungsversuche mehr übrig",
      ],
      "Loading verification…": ["Verifizierung wird geladen…"],
      "This can take a few seconds.": ["Dies kann einige Sekunden dauern."],
      "Verification service unavailable": [
        "Verifizierungsdienst nicht verfügbar",
      ],
      "We could not load this verification": [
        "Diese Verifizierung konnte nicht geladen werden",
      ],
      "Check your connection and try again. Your progress is safe.": [
        "Überprüfen Sie Ihre Verbindung und versuchen Sie es erneut. Ihr Fortschritt bleibt erhalten.",
      ],
      "Loading…": ["Wird geladen…"],
      "Try again": ["Erneut versuchen"],
      "Verification link expired": ["Verifizierungslink abgelaufen"],
      "Invalid verification link": ["Ungültiger Verifizierungslink"],
      "This verification is no longer available. Return to the application and start again.":
        [
          "Diese Verifizierung ist nicht mehr verfügbar. Kehren Sie zur Anwendung zurück und starten Sie erneut.",
        ],
      "Return to the application and start a new verification.": [
        "Kehren Sie zur Anwendung zurück und starten Sie eine neue Verifizierung.",
      ],
      "The service had a temporary problem. Try again.": [
        "Beim Dienst ist ein vorübergehendes Problem aufgetreten. Versuchen Sie es erneut.",
      ],
      "The verification request is incomplete or invalid.": [
        "Die Verifizierungsanfrage ist unvollständig oder ungültig.",
      ],
      "Continuing…": ["Weiter…"],
      "Loading contact details…": ["Kontaktdaten werden geladen…"],
      "We could not load your verification": [
        "Ihre Verifizierung konnte nicht geladen werden",
      ],
      "Could not load verification details": [
        "Verifizierungsdetails konnten nicht geladen werden",
      ],
      "Verification unavailable": ["Verifizierung nicht verfügbar"],
      "This verification has expired. Return to the application and start again.":
        [
          "Diese Verifizierung ist abgelaufen. Kehren Sie zur Anwendung zurück und starten Sie erneut.",
        ],
      "No attempts remain. Return to the application and start a new verification.":
        [
          "Es sind keine Versuche mehr übrig. Kehren Sie zur Anwendung zurück und starten Sie eine neue Verifizierung.",
        ],
      "The service rejected this verification request.": [
        "Der Dienst hat diese Verifizierungsanfrage abgelehnt.",
      ],
      "Invalid validation rule: %1$s": ["Ungültige Validierungsregel: %1$s"],
      "Service configuration error": ["Konfigurationsfehler des Dienstes"],
      "The service cannot validate this address right now. Please return to the application and try again later.":
        [
          "Der Dienst kann diese Adresse derzeit nicht überprüfen. Kehren Sie zur Anwendung zurück und versuchen Sie es später erneut.",
        ],
      "We could not contact the verification service. Check your connection and try again.":
        [
          "Der Verifizierungsdienst konnte nicht erreicht werden. Überprüfen Sie Ihre Verbindung und versuchen Sie es erneut.",
        ],
      "Verify your email address": ["E-Mail-Adresse verifizieren"],
      "Verify your phone number": ["Telefonnummer verifizieren"],
      "Verify your postal address": ["Postadresse verifizieren"],
      "We will email you a one-time verification code.": [
        "Wir senden Ihnen einen einmaligen Verifizierungscode per E-Mail.",
      ],
      "We will send you a one-time verification code by SMS.": [
        "Wir senden Ihnen einen einmaligen Verifizierungscode per SMS.",
      ],
      "We will send you a letter containing a one-time verification code.": [
        "Wir senden Ihnen einen Brief mit einem einmaligen Verifizierungscode.",
      ],
      "Change your email address": ["E-Mail-Adresse ändern"],
      "Change your phone number": ["Telefonnummer ändern"],
      "Change your postal address": ["Postadresse ändern"],
      "Enter the email address where you want to receive a new verification code.":
        [
          "Geben Sie die E-Mail-Adresse ein, an die der neue Verifizierungscode gesendet werden soll.",
        ],
      "Enter the phone number where you want to receive a new verification code.":
        [
          "Geben Sie die Telefonnummer ein, an die der neue Verifizierungscode gesendet werden soll.",
        ],
      "Enter the postal address where you want to receive a new verification code.":
        [
          "Geben Sie die Postadresse ein, an die der neue Verifizierungscode gesendet werden soll.",
        ],
      "Current email address": ["Aktuelle E-Mail-Adresse"],
      "Current phone number": ["Aktuelle Telefonnummer"],
      "Current postal address": ["Aktuelle Postadresse"],
      "New postal address": ["Neue Postadresse"],
      "Last available change": ["Letzte verfügbare Änderung"],
      "You can change the email address one more time.": [
        "Sie können die E-Mail-Adresse noch einmal ändern.",
      ],
      "You can change the phone number one more time.": [
        "Sie können die Telefonnummer noch einmal ändern.",
      ],
      "You can change the postal address one more time.": [
        "Sie können die Postadresse noch einmal ändern.",
      ],
      "Change at least one field to continue.": [
        "Ändern Sie mindestens ein Feld, um fortzufahren.",
      ],
      "The previous code sent to %1$s can still be used.": [
        "Der zuvor an %1$s gesendete Code kann weiterhin verwendet werden.",
      ],
      "Back to code entry": ["Zurück zur Codeeingabe"],
      "No changes remaining": ["Keine Änderungen mehr möglich"],
      "Email address cannot be changed": [
        "E-Mail-Adresse kann nicht geändert werden",
      ],
      "Phone number cannot be changed": [
        "Telefonnummer kann nicht geändert werden",
      ],
      "Postal address cannot be changed": [
        "Postadresse kann nicht geändert werden",
      ],
      "This email address cannot be changed.": [
        "Diese E-Mail-Adresse kann nicht geändert werden.",
      ],
      "This phone number cannot be changed.": [
        "Diese Telefonnummer kann nicht geändert werden.",
      ],
      "This postal address cannot be changed.": [
        "Diese Postadresse kann nicht geändert werden.",
      ],
      "Code could not be sent": ["Code konnte nicht gesendet werden"],
      "Sending code…": ["Code wird gesendet…"],
      "Send verification code": ["Verifizierungscode senden"],
      "Send code to new email address": ["Code an neue E-Mail-Adresse senden"],
      "Send code to new phone number": ["Code an neue Telefonnummer senden"],
      "Send code to new postal address": ["Code an neue Postadresse senden"],
      "The code could not be delivered to this destination. Check it or use a different one.":
        [
          "Der Code konnte nicht an dieses Ziel zugestellt werden. Überprüfen Sie es oder verwenden Sie ein anderes.",
        ],
      "This destination does not meet the service requirements. Check the highlighted fields.":
        [
          "Dieses Ziel erfüllt die Anforderungen des Dienstes nicht. Überprüfen Sie die markierten Felder.",
        ],
      "This destination could not be used. Check it and try again.": [
        "Dieses Ziel konnte nicht verwendet werden. Überprüfen Sie es und versuchen Sie es erneut.",
      ],
      "This destination is fixed and cannot be changed.": [
        "Dieses Ziel ist fest vorgegeben und kann nicht geändert werden.",
      ],
      "The verification service is not configured to send this code.": [
        "Der Verifizierungsdienst ist nicht zum Senden dieses Codes konfiguriert.",
      ],
      "The destination is too long. Shorten it and try again.": [
        "Das Ziel ist zu lang. Kürzen Sie es und versuchen Sie es erneut.",
      ],
      "The verification page and service are incompatible.": [
        "Die Verifizierungsseite und der Dienst sind nicht kompatibel.",
      ],
      "No more codes can be sent for this verification. Use a different destination or start again.":
        [
          "Für diese Verifizierung können keine weiteren Codes gesendet werden. Verwenden Sie ein anderes Ziel oder starten Sie erneut.",
        ],
      "The delivery service is temporarily unavailable. Try again in a moment.":
        [
          "Der Zustelldienst ist vorübergehend nicht verfügbar. Versuchen Sie es gleich erneut.",
        ],
      "The verification service had a temporary problem. Try again.": [
        "Beim Verifizierungsdienst ist ein vorübergehendes Problem aufgetreten. Versuchen Sie es erneut.",
      ],
      "The code could not be sent. Try again.": [
        "Der Code konnte nicht gesendet werden. Versuchen Sie es erneut.",
      ],
      "Enter a valid value.": ["Geben Sie einen gültigen Wert ein."],
      "Email": ["E-Mail"],
      "New email address": ["Neue E-Mail-Adresse"],
      "Phone": ["Telefon"],
      "New phone number": ["Neue Telefonnummer"],
      "Contact name": ["Kontaktname"],
      "Full name of the person or business": [
        "Vollständiger Name der Person oder des Unternehmens",
      ],
      "Address": ["Adresse"],
      "Street and house number\nAdditional address information\nPostal code and city":
        [
          "Straße und Hausnummer\nZusätzliche Adressangaben\nPostleitzahl und Ort",
        ],
      "Country": ["Land"],
      "Your full name": ["Ihr vollständiger Name"],
      "Swiss address": ["Schweizer Adresse"],
      "Make sure this is a Swiss address.": [
        "Stellen Sie sicher, dass dies eine Schweizer Adresse ist.",
      ],
      "The verification code is incorrect.": [
        "Der Verifizierungscode ist falsch.",
      ],
      "The verification service rejected this request.": [
        "Der Verifizierungsdienst hat diese Anfrage abgelehnt.",
      ],
      "Updating verification status…": [
        "Verifizierungsstatus wird aktualisiert…",
      ],
      "This verification code can no longer be used": [
        "Dieser Verifizierungscode kann nicht mehr verwendet werden",
      ],
      "Choose another available option or return to the application and start again.":
        [
          "Wählen Sie eine andere verfügbare Option oder kehren Sie zur Anwendung zurück und starten Sie erneut.",
        ],
      "Enter your verification code": [
        "Geben Sie Ihren Verifizierungscode ein",
      ],
      "Enter the one-time verification code you received.": [
        "Geben Sie den erhaltenen einmaligen Verifizierungscode ein.",
      ],
      "New code sent": ["Neuer Code gesendet"],
      "A new code was sent. Enter the latest code you received.": [
        "Ein neuer Code wurde gesendet. Geben Sie den zuletzt erhaltenen Code ein.",
      ],
      "Verification code": ["Verifizierungscode"],
      "Code not accepted": ["Code nicht akzeptiert"],
      "This is your last attempt with the current code.": [
        "Dies ist Ihr letzter Versuch mit dem aktuellen Code.",
      ],
      "Verifying…": ["Wird verifiziert…"],
      "Verify code": ["Code verifizieren"],
      "We sent a one-time verification code to %1$s.": [
        "Wir haben einen einmaligen Verifizierungscode an %1$s gesendet.",
      ],
      "Use a different email address": ["Andere E-Mail-Adresse verwenden"],
      "Use a different phone number": ["Andere Telefonnummer verwenden"],
      "Use a different postal address": ["Andere Postadresse verwenden"],
      "The email address can no longer be changed.": [
        "Die E-Mail-Adresse kann nicht mehr geändert werden.",
      ],
      "The phone number can no longer be changed.": [
        "Die Telefonnummer kann nicht mehr geändert werden.",
      ],
      "The postal address can no longer be changed.": [
        "Die Postadresse kann nicht mehr geändert werden.",
      ],
      "Sending a new code…": ["Neuer Code wird gesendet…"],
      "Send a new code": ["Neuen Code senden"],
      "Didn't receive a code?": ["Keinen Code erhalten?"],
      "Continue verification": ["Verifizierung fortsetzen"],
      "You can send a new code in %1$s.": [
        "Sie können in %1$s einen neuen Code senden.",
      ],
      "No more codes can be sent for this verification.": [
        "Für diese Verifizierung können keine weiteren Codes gesendet werden.",
      ],
      "No destination is available for another code.": [
        "Es ist kein Ziel verfügbar, an das ein weiterer Code gesendet werden kann.",
      ],
      "The verification code must contain only numbers.": [
        "Der Verifizierungscode darf nur Zahlen enthalten.",
      ],
      "The verification code is too long.": [
        "Der Verifizierungscode ist zu lang.",
      ],
      "The verification code could not be checked. Try again.": [
        "Der Verifizierungscode konnte nicht geprüft werden. Versuchen Sie es erneut.",
      ],
      "Continue to %1$s": ["Weiter zu %1$s"],
      "Verification complete": ["Verifizierung abgeschlossen"],
      "Return to the application that started this verification.": [
        "Kehren Sie zu der Anwendung zurück, die diese Verifizierung gestartet hat.",
      ],
      "Use the button below to continue immediately.": [
        "Mit der Schaltfläche unten können Sie sofort fortfahren.",
      ],
      "You will be redirected to %1$s automatically.": [
        "Sie werden automatisch zu %1$s weitergeleitet.",
      ],
      "Redirecting in 1 second…": ["Weiterleitung in 1 Sekunde…"],
      "Redirecting in %1$s seconds…": ["Weiterleitung in %1$s Sekunden…"],
      "Automatic return is unavailable": [
        "Automatische Rückkehr nicht verfügbar",
      ],
      "Address verified": ["Adresse verifiziert"],
      "Identity verification": ["Identitätsverifizierung"],
      "Something went wrong": ["Etwas ist schiefgegangen"],
      "Reload this page. If the problem continues, return to the application that started the verification.":
        [
          "Laden Sie diese Seite neu. Falls das Problem weiterhin besteht, kehren Sie zu der Anwendung zurück, die die Verifizierung gestartet hat.",
        ],
      "Client password": ["Client-Passwort"],
      "Redirect URL": ["Weiterleitungs-URL"],
      "Required": ["Erforderlich"],
      "Enter a valid HTTP or HTTPS URL": [
        "Geben Sie eine gültige HTTP- oder HTTPS-URL ein",
      ],
      "The client ID or password is not recognized by this service.": [
        "Die Client-ID oder das Passwort wird von diesem Dienst nicht erkannt.",
      ],
      "The verification session could not be created.": [
        "Die Verifizierungssitzung konnte nicht erstellt werden.",
      ],
      "We could not contact the verification service. Check the service URL and try again.":
        [
          "Der Verifizierungsdienst konnte nicht erreicht werden. Überprüfen Sie die Dienst-URL und versuchen Sie es erneut.",
        ],
      "Create a verification session": ["Verifizierungssitzung erstellen"],
      "Session not created": ["Sitzung nicht erstellt"],
      "Creating session…": ["Sitzung wird erstellt…"],
      "Create session": ["Sitzung erstellen"],
      "Developer setup for client %1$s": [
        "Entwicklereinrichtung für Client %1$s",
      ],
      "No verification attempts or address changes remain.": [
        "Es sind keine Verifizierungsversuche oder Adressänderungen mehr möglich.",
      ],
      "Verification information unavailable": [
        "Verifizierungsinformationen nicht verfügbar",
      ],
      "Nothing to verify": ["Nichts zu verifizieren"],
      "Return to the application that sent you here and start the verification again.":
        [
          "Kehren Sie zu der Anwendung zurück, die Sie hierher geschickt hat, und starten Sie die Verifizierung erneut.",
        ],
      "Required information is missing": ["Erforderliche Informationen fehlen"],
      "Preparing verification…": ["Verifizierung wird vorbereitet…"],
      "Retry %1$s of %2$s": ["Versuch %1$s von %2$s"],
      "Reconnecting to the verification service…": [
        "Verbindung zum Verifizierungsdienst wird wiederhergestellt…",
      ],
      "Connecting to the verification service…": [
        "Verbindung zum Verifizierungsdienst wird hergestellt…",
      ],
      "unknown": ["unbekannt"],
      "Supported version: %1$s. Service version: %2$s.": [
        "Unterstützte Version: %1$s. Dienstversion: %2$s.",
      ],
      "Verification service update required": [
        "Aktualisierung des Verifizierungsdienstes erforderlich",
      ],
      "Versions are incompatible": ["Versionen sind nicht kompatibel"],
      "This verification page cannot communicate with the service. Please return to the application that sent you here.":
        [
          "Diese Verifizierungsseite kann nicht mit dem Dienst kommunizieren. Kehren Sie zu der Anwendung zurück, die Sie hierher geschickt hat.",
        ],
      "We could not connect": ["Verbindung konnte nicht hergestellt werden"],
      "Check your connection and try again. Your verification information has not been changed.":
        [
          "Überprüfen Sie Ihre Verbindung und versuchen Sie es erneut. Ihre Verifizierungsinformationen wurden nicht geändert.",
        ],
      "Connecting…": ["Verbindung wird hergestellt…"],
    },
  },
  domain: "messages",
  plural_forms: "nplurals=2; plural=(n != 1);",
  lang: "de",
  completeness: 100,
  _pogen: {
    total: 167,
    translated: 167,
    untranslated: [],
    optional: [],
  },
};

strings["de-CH"] = {
  locale_data: {
    messages: {
      "": {
        domain: "messages",
        lang: "de-CH",
        plural_forms: "nplurals=2; plural=(n != 1);",
      },
      "Contact": ["Kontakt"],
      "Code": ["Code"],
      "Complete": ["Fertig"],
      "Verification progress": ["Verifizierungsfortschritt"],
      "Technical details": ["Technische Details"],
      "Copy details": ["Details kopieren"],
      "Copied": ["Kopiert"],
      "Return to %1$s": ["Zurück zu %1$s"],
      "No attempts remain": ["Keine Versuche mehr übrig"],
      "No verification attempts remain": [
        "Keine Verifizierungsversuche mehr übrig",
      ],
      "Loading verification…": ["Verifizierung wird geladen…"],
      "This can take a few seconds.": ["Dies kann einige Sekunden dauern."],
      "Verification service unavailable": [
        "Verifizierungsdienst nicht verfügbar",
      ],
      "We could not load this verification": [
        "Diese Verifizierung konnte nicht geladen werden",
      ],
      "Check your connection and try again. Your progress is safe.": [
        "Überprüfen Sie Ihre Verbindung und versuchen Sie es erneut. Ihr Fortschritt bleibt erhalten.",
      ],
      "Loading…": ["Wird geladen…"],
      "Try again": ["Erneut versuchen"],
      "Verification link expired": ["Verifizierungslink abgelaufen"],
      "Invalid verification link": ["Ungültiger Verifizierungslink"],
      "This verification is no longer available. Return to the application and start again.":
        [
          "Diese Verifizierung ist nicht mehr verfügbar. Kehren Sie zur Anwendung zurück und starten Sie erneut.",
        ],
      "Return to the application and start a new verification.": [
        "Kehren Sie zur Anwendung zurück und starten Sie eine neue Verifizierung.",
      ],
      "The service had a temporary problem. Try again.": [
        "Beim Dienst ist ein vorübergehendes Problem aufgetreten. Versuchen Sie es erneut.",
      ],
      "The verification request is incomplete or invalid.": [
        "Die Verifizierungsanfrage ist unvollständig oder ungültig.",
      ],
      "Continuing…": ["Weiter…"],
      "Loading contact details…": ["Kontaktdaten werden geladen…"],
      "We could not load your verification": [
        "Ihre Verifizierung konnte nicht geladen werden",
      ],
      "Could not load verification details": [
        "Verifizierungsdetails konnten nicht geladen werden",
      ],
      "Verification unavailable": ["Verifizierung nicht verfügbar"],
      "This verification has expired. Return to the application and start again.":
        [
          "Diese Verifizierung ist abgelaufen. Kehren Sie zur Anwendung zurück und starten Sie erneut.",
        ],
      "No attempts remain. Return to the application and start a new verification.":
        [
          "Es sind keine Versuche mehr übrig. Kehren Sie zur Anwendung zurück und starten Sie eine neue Verifizierung.",
        ],
      "The service rejected this verification request.": [
        "Der Dienst hat diese Verifizierungsanfrage abgelehnt.",
      ],
      "Invalid validation rule: %1$s": ["Ungültige Validierungsregel: %1$s"],
      "Service configuration error": ["Konfigurationsfehler des Dienstes"],
      "The service cannot validate this address right now. Please return to the application and try again later.":
        [
          "Der Dienst kann diese Adresse derzeit nicht überprüfen. Kehren Sie zur Anwendung zurück und versuchen Sie es später erneut.",
        ],
      "We could not contact the verification service. Check your connection and try again.":
        [
          "Der Verifizierungsdienst konnte nicht erreicht werden. Überprüfen Sie Ihre Verbindung und versuchen Sie es erneut.",
        ],
      "Verify your email address": ["E-Mail-Adresse verifizieren"],
      "Verify your phone number": ["Telefonnummer verifizieren"],
      "Verify your postal address": ["Postadresse verifizieren"],
      "We will email you a one-time verification code.": [
        "Wir senden Ihnen einen einmaligen Verifizierungscode per E-Mail.",
      ],
      "We will send you a one-time verification code by SMS.": [
        "Wir senden Ihnen einen einmaligen Verifizierungscode per SMS.",
      ],
      "We will send you a letter containing a one-time verification code.": [
        "Wir senden Ihnen einen Brief mit einem einmaligen Verifizierungscode.",
      ],
      "Change your email address": ["E-Mail-Adresse ändern"],
      "Change your phone number": ["Telefonnummer ändern"],
      "Change your postal address": ["Postadresse ändern"],
      "Enter the email address where you want to receive a new verification code.":
        [
          "Geben Sie die E-Mail-Adresse ein, an die der neue Verifizierungscode gesendet werden soll.",
        ],
      "Enter the phone number where you want to receive a new verification code.":
        [
          "Geben Sie die Telefonnummer ein, an die der neue Verifizierungscode gesendet werden soll.",
        ],
      "Enter the postal address where you want to receive a new verification code.":
        [
          "Geben Sie die Postadresse ein, an die der neue Verifizierungscode gesendet werden soll.",
        ],
      "Current email address": ["Aktuelle E-Mail-Adresse"],
      "Current phone number": ["Aktuelle Telefonnummer"],
      "Current postal address": ["Aktuelle Postadresse"],
      "New postal address": ["Neue Postadresse"],
      "Last available change": ["Letzte verfügbare Änderung"],
      "You can change the email address one more time.": [
        "Sie können die E-Mail-Adresse noch einmal ändern.",
      ],
      "You can change the phone number one more time.": [
        "Sie können die Telefonnummer noch einmal ändern.",
      ],
      "You can change the postal address one more time.": [
        "Sie können die Postadresse noch einmal ändern.",
      ],
      "Change at least one field to continue.": [
        "Ändern Sie mindestens ein Feld, um fortzufahren.",
      ],
      "The previous code sent to %1$s can still be used.": [
        "Der zuvor an %1$s gesendete Code kann weiterhin verwendet werden.",
      ],
      "Back to code entry": ["Zurück zur Codeeingabe"],
      "No changes remaining": ["Keine Änderungen mehr möglich"],
      "Email address cannot be changed": [
        "E-Mail-Adresse kann nicht geändert werden",
      ],
      "Phone number cannot be changed": [
        "Telefonnummer kann nicht geändert werden",
      ],
      "Postal address cannot be changed": [
        "Postadresse kann nicht geändert werden",
      ],
      "This email address cannot be changed.": [
        "Diese E-Mail-Adresse kann nicht geändert werden.",
      ],
      "This phone number cannot be changed.": [
        "Diese Telefonnummer kann nicht geändert werden.",
      ],
      "This postal address cannot be changed.": [
        "Diese Postadresse kann nicht geändert werden.",
      ],
      "Code could not be sent": ["Code konnte nicht gesendet werden"],
      "Sending code…": ["Code wird gesendet…"],
      "Send verification code": ["Verifizierungscode senden"],
      "Send code to new email address": ["Code an neue E-Mail-Adresse senden"],
      "Send code to new phone number": ["Code an neue Telefonnummer senden"],
      "Send code to new postal address": ["Code an neue Postadresse senden"],
      "The code could not be delivered to this destination. Check it or use a different one.":
        [
          "Der Code konnte nicht an dieses Ziel zugestellt werden. Überprüfen Sie es oder verwenden Sie ein anderes.",
        ],
      "This destination does not meet the service requirements. Check the highlighted fields.":
        [
          "Dieses Ziel erfüllt die Anforderungen des Dienstes nicht. Überprüfen Sie die markierten Felder.",
        ],
      "This destination could not be used. Check it and try again.": [
        "Dieses Ziel konnte nicht verwendet werden. Überprüfen Sie es und versuchen Sie es erneut.",
      ],
      "This destination is fixed and cannot be changed.": [
        "Dieses Ziel ist fest vorgegeben und kann nicht geändert werden.",
      ],
      "The verification service is not configured to send this code.": [
        "Der Verifizierungsdienst ist nicht zum Senden dieses Codes konfiguriert.",
      ],
      "The destination is too long. Shorten it and try again.": [
        "Das Ziel ist zu lang. Kürzen Sie es und versuchen Sie es erneut.",
      ],
      "The verification page and service are incompatible.": [
        "Die Verifizierungsseite und der Dienst sind nicht kompatibel.",
      ],
      "No more codes can be sent for this verification. Use a different destination or start again.":
        [
          "Für diese Verifizierung können keine weiteren Codes gesendet werden. Verwenden Sie ein anderes Ziel oder starten Sie erneut.",
        ],
      "The delivery service is temporarily unavailable. Try again in a moment.":
        [
          "Der Zustelldienst ist vorübergehend nicht verfügbar. Versuchen Sie es gleich erneut.",
        ],
      "The verification service had a temporary problem. Try again.": [
        "Beim Verifizierungsdienst ist ein vorübergehendes Problem aufgetreten. Versuchen Sie es erneut.",
      ],
      "The code could not be sent. Try again.": [
        "Der Code konnte nicht gesendet werden. Versuchen Sie es erneut.",
      ],
      "Enter a valid value.": ["Geben Sie einen gültigen Wert ein."],
      "Email": ["E-Mail"],
      "New email address": ["Neue E-Mail-Adresse"],
      "Phone": ["Telefon"],
      "New phone number": ["Neue Telefonnummer"],
      "Contact name": ["Kontaktname"],
      "Full name of the person or business": [
        "Vollständiger Name der Person oder des Unternehmens",
      ],
      "Address": ["Adresse"],
      "Street and house number\nAdditional address information\nPostal code and city":
        [
          "Strasse und Hausnummer\nZusätzliche Adressangaben\nPostleitzahl und Ort",
        ],
      "Country": ["Land"],
      "Your full name": ["Ihr vollständiger Name"],
      "Swiss address": ["Schweizer Adresse"],
      "Make sure this is a Swiss address.": [
        "Stellen Sie sicher, dass dies eine Schweizer Adresse ist.",
      ],
      "The verification code is incorrect.": [
        "Der Verifizierungscode ist falsch.",
      ],
      "The verification service rejected this request.": [
        "Der Verifizierungsdienst hat diese Anfrage abgelehnt.",
      ],
      "Updating verification status…": [
        "Verifizierungsstatus wird aktualisiert…",
      ],
      "This verification code can no longer be used": [
        "Dieser Verifizierungscode kann nicht mehr verwendet werden",
      ],
      "Choose another available option or return to the application and start again.":
        [
          "Wählen Sie eine andere verfügbare Option oder kehren Sie zur Anwendung zurück und starten Sie erneut.",
        ],
      "Enter your verification code": [
        "Geben Sie Ihren Verifizierungscode ein",
      ],
      "Enter the one-time verification code you received.": [
        "Geben Sie den erhaltenen einmaligen Verifizierungscode ein.",
      ],
      "New code sent": ["Neuer Code gesendet"],
      "A new code was sent. Enter the latest code you received.": [
        "Ein neuer Code wurde gesendet. Geben Sie den zuletzt erhaltenen Code ein.",
      ],
      "Verification code": ["Verifizierungscode"],
      "Code not accepted": ["Code nicht akzeptiert"],
      "This is your last attempt with the current code.": [
        "Dies ist Ihr letzter Versuch mit dem aktuellen Code.",
      ],
      "Verifying…": ["Wird verifiziert…"],
      "Verify code": ["Code verifizieren"],
      "We sent a one-time verification code to %1$s.": [
        "Wir haben einen einmaligen Verifizierungscode an %1$s gesendet.",
      ],
      "Use a different email address": ["Andere E-Mail-Adresse verwenden"],
      "Use a different phone number": ["Andere Telefonnummer verwenden"],
      "Use a different postal address": ["Andere Postadresse verwenden"],
      "The email address can no longer be changed.": [
        "Die E-Mail-Adresse kann nicht mehr geändert werden.",
      ],
      "The phone number can no longer be changed.": [
        "Die Telefonnummer kann nicht mehr geändert werden.",
      ],
      "The postal address can no longer be changed.": [
        "Die Postadresse kann nicht mehr geändert werden.",
      ],
      "Sending a new code…": ["Neuer Code wird gesendet…"],
      "Send a new code": ["Neuen Code senden"],
      "Didn't receive a code?": ["Keinen Code erhalten?"],
      "Continue verification": ["Verifizierung fortsetzen"],
      "You can send a new code in %1$s.": [
        "Sie können in %1$s einen neuen Code senden.",
      ],
      "No more codes can be sent for this verification.": [
        "Für diese Verifizierung können keine weiteren Codes gesendet werden.",
      ],
      "No destination is available for another code.": [
        "Es ist kein Ziel verfügbar, an das ein weiterer Code gesendet werden kann.",
      ],
      "The verification code must contain only numbers.": [
        "Der Verifizierungscode darf nur Zahlen enthalten.",
      ],
      "The verification code is too long.": [
        "Der Verifizierungscode ist zu lang.",
      ],
      "The verification code could not be checked. Try again.": [
        "Der Verifizierungscode konnte nicht geprüft werden. Versuchen Sie es erneut.",
      ],
      "Continue to %1$s": ["Weiter zu %1$s"],
      "Verification complete": ["Verifizierung abgeschlossen"],
      "Return to the application that started this verification.": [
        "Kehren Sie zu der Anwendung zurück, die diese Verifizierung gestartet hat.",
      ],
      "Use the button below to continue immediately.": [
        "Mit der Schaltfläche unten können Sie sofort fortfahren.",
      ],
      "You will be redirected to %1$s automatically.": [
        "Sie werden automatisch zu %1$s weitergeleitet.",
      ],
      "Redirecting in 1 second…": ["Weiterleitung in 1 Sekunde…"],
      "Redirecting in %1$s seconds…": ["Weiterleitung in %1$s Sekunden…"],
      "Automatic return is unavailable": [
        "Automatische Rückkehr nicht verfügbar",
      ],
      "Address verified": ["Adresse verifiziert"],
      "Identity verification": ["Identitätsverifizierung"],
      "Something went wrong": ["Etwas ist schiefgegangen"],
      "Reload this page. If the problem continues, return to the application that started the verification.":
        [
          "Laden Sie diese Seite neu. Falls das Problem weiterhin besteht, kehren Sie zu der Anwendung zurück, die die Verifizierung gestartet hat.",
        ],
      "Client password": ["Client-Passwort"],
      "Redirect URL": ["Weiterleitungs-URL"],
      "Required": ["Erforderlich"],
      "Enter a valid HTTP or HTTPS URL": [
        "Geben Sie eine gültige HTTP- oder HTTPS-URL ein",
      ],
      "The client ID or password is not recognized by this service.": [
        "Die Client-ID oder das Passwort wird von diesem Dienst nicht erkannt.",
      ],
      "The verification session could not be created.": [
        "Die Verifizierungssitzung konnte nicht erstellt werden.",
      ],
      "We could not contact the verification service. Check the service URL and try again.":
        [
          "Der Verifizierungsdienst konnte nicht erreicht werden. Überprüfen Sie die Dienst-URL und versuchen Sie es erneut.",
        ],
      "Create a verification session": ["Verifizierungssitzung erstellen"],
      "Session not created": ["Sitzung nicht erstellt"],
      "Creating session…": ["Sitzung wird erstellt…"],
      "Create session": ["Sitzung erstellen"],
      "Developer setup for client %1$s": [
        "Entwicklereinrichtung für Client %1$s",
      ],
      "No verification attempts or address changes remain.": [
        "Es sind keine Verifizierungsversuche oder Adressänderungen mehr möglich.",
      ],
      "Verification information unavailable": [
        "Verifizierungsinformationen nicht verfügbar",
      ],
      "Nothing to verify": ["Nichts zu verifizieren"],
      "Return to the application that sent you here and start the verification again.":
        [
          "Kehren Sie zu der Anwendung zurück, die Sie hierher geschickt hat, und starten Sie die Verifizierung erneut.",
        ],
      "Required information is missing": ["Erforderliche Informationen fehlen"],
      "Preparing verification…": ["Verifizierung wird vorbereitet…"],
      "Retry %1$s of %2$s": ["Versuch %1$s von %2$s"],
      "Reconnecting to the verification service…": [
        "Verbindung zum Verifizierungsdienst wird wiederhergestellt…",
      ],
      "Connecting to the verification service…": [
        "Verbindung zum Verifizierungsdienst wird hergestellt…",
      ],
      "unknown": ["unbekannt"],
      "Supported version: %1$s. Service version: %2$s.": [
        "Unterstützte Version: %1$s. Dienstversion: %2$s.",
      ],
      "Verification service update required": [
        "Aktualisierung des Verifizierungsdienstes erforderlich",
      ],
      "Versions are incompatible": ["Versionen sind nicht kompatibel"],
      "This verification page cannot communicate with the service. Please return to the application that sent you here.":
        [
          "Diese Verifizierungsseite kann nicht mit dem Dienst kommunizieren. Kehren Sie zu der Anwendung zurück, die Sie hierher geschickt hat.",
        ],
      "We could not connect": ["Verbindung konnte nicht hergestellt werden"],
      "Check your connection and try again. Your verification information has not been changed.":
        [
          "Überprüfen Sie Ihre Verbindung und versuchen Sie es erneut. Ihre Verifizierungsinformationen wurden nicht geändert.",
        ],
      "Connecting…": ["Verbindung wird hergestellt…"],
    },
  },
  domain: "messages",
  plural_forms: "nplurals=2; plural=(n != 1);",
  lang: "de-CH",
  completeness: 100,
  _pogen: {
    total: 167,
    translated: 167,
    untranslated: [],
    optional: [],
  },
};

const pogenComposedStrings = composeTranslationCatalogues(
  pogenDependencyCatalogue0,
  strings as Parameters<typeof composeTranslationCatalogues>[0],
);
for (const language of Object.keys(strings)) delete strings[language];
Object.assign(strings, pogenComposedStrings);
